import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { UserServiceResources as us } from 'se-resource-types'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root'
})
export class InviteService {

  constructor(
    private api: UserServiceApiService
  ) { }

  public find(token: string, params = { }): Observable<us.Invitation> {
    const url = `invitations/${token}`

    return this.api.get<us.Invitation>(url, { params })
      .pipe(
        first(),
        map(r => r.result)
      )
  }

  public update(token: string, data: any): Observable<us.Invitation> {
    return this.updateRequest(`invitations/${token}`, data)
  }

  public resend(token: string): Observable<us.Invitation> {
    return this.updateRequest(`invitations/${token}/resend`)
  }

  public cancel(token: string): Observable<us.Invitation> {
    return this.updateRequest(`invitations/${token}/cancel`)
  }

  private updateRequest(path: string, data: any = {}): Observable<us.Invitation> {
    return this.api.put<us.Invitation>(path, data)
      .pipe(
        first(),
        map(r => r.result)
      )
  }
}
